import { UiHeaderVariant } from '../../ui.enums';

export const defaultVariant = UiHeaderVariant.Span;
